import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "./index.css";
import "react-day-picker/lib/style.css";
import App from "./App";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://a3bfa9b9e48046a5bf03c4972b9b2547@o274315.ingest.sentry.io/5919799",
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [process.env.REACT_APP_VACATION_API_URL as string],
      }),
    ],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV as string,
    attachStacktrace: true,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
